import { ReactNode, useEffect } from 'react'
import classNames from 'classnames'

import { useAppContext } from 'client/hooks'

import AppHeader from '../AppHeader/app-header'
import AppDivider from '../AppDivider/app-divider'

import styles from './app-notifications.module.scss'

type Props = {
  children: ReactNode
}

const AppNotifications = ({ children = null }: Props) => {
  const { showAppNotifications, setShowAppNotifications } = useAppContext()

  useEffect(() => {
    const listener = () => {
      if (showAppNotifications) {
        setShowAppNotifications(false)
      }
    }
    if (showAppNotifications) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    document.addEventListener('click', listener)
    return () => {
      document.removeEventListener('click', listener)
    }
  }, [showAppNotifications])

  return (
    <div
      className={classNames(
        styles.appNotifications,
        showAppNotifications && styles.visible
      )}
      onClick={e => e.stopPropagation()}
    >
      <AppDivider size="xxsmall" />
      <AppHeader
        text="Your activity"
        size="small"
        centered
        marginBottom="xxsmall"
        color="light"
      />
      <div>{showAppNotifications ? children : null}</div>
    </div>
  )
}

export default AppNotifications
